<template>
  <DefaultPage>
    <div class="hero hero-tall">
      <PillsRandom
        hero
        context="for-doctors"
        :columns="40"
      />
      <div class="hero-flex-wrap">
        <div class="grid-container">
          <div class="grid-x grid-margin-x align-middle">
            <div class="cell large-6">
              <div class="hero__call">
                <div class="hero-part">
                  <h1 class="hero__headline__small">
                    Created <span class="text-gold italic-light">by</span> doctors<br/><span class="text-gold italic-light">for</span> doctors
                  </h1>
                </div>
              </div>
            </div>
            <div class="cell large-6">
              <div class="hero-part">
                <div class="hero__call__content">
                  <p>Our teams of experts work hard to provide our members with the most robust set of resources possible to help protect their practices from risk. We collaborate with our members, our internal teams, and leading industry experts to produce relevant and insightful content that helps make better physicians.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="section section--gray">
      <div class="grid-container">
        <div class="grid-x grid-margin-x align-center">
          <div class="cell medium-6" data-aos="fade-up">
            <div class="doctor-section-left">
              <div class="doctor-section-content">
                <h3>&ldquo;As we move forward, having a partner like SVMIC is for your benefit in the long haul.&rdquo;</h3>
                <h4>Antwan D. Robinson, MD</h4>
                <h6>Cardiology<br/>Board Member</h6>
                <PillsAccent
                  :top="-85"
                  :left="-95"
                >
                  <PillColumn>
                    <Pill
                      color="indigo"
                      height="xtall"
                    />
                    <Pill
                      color="paleBlue"
                      height="xtall"
                      :offset="2"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="gold"
                      height="xtall"
                      :offset="2"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="purple"
                      height="xxtall"
                      :offset="-1"
                    />
                  </PillColumn>
                </PillsAccent>
              </div>
            </div>
          </div>
          <div class="cell medium-6">
            <div class="doctor-section-right">
              <div class="doctor-section-video-wrap">
                <div class="pill-mask">
                  <video
                    class="pill-video"
                    ref="pillVideo1"
                    playsinline=""
                    :poster="`${baseUrl}videos/antwan-robinson-video-placeholder.jpg`"
                    @click="handleVideoClick($event, 0)"
                    @ended="handleVideoEnd($event, 0)"
                  >
                    <source
                      type="video/mp4"
                      :src="`${baseUrl}videos/Antwan-Robinson-Pullquote.mp4`"
                    >
                  </video>
                  <img
                    class="pill-photo"
                    ref="pillPoster1"
                    :src="`${baseUrl}videos/antwan-robinson-video-placeholder.jpg`"
                    @click="handlePosterClick($event, 0)"
                  />
                </div>
                <div class="video-play video-play-left">
                  <span class="video-play-text">play video</span>
                  <div class="video-play-line" />
                  <a
                    href="#"
                    class="video-play-button"
                    @click="handlePlayButtonClick($event, 0)"
                  >
                    <FontAwesomeIcon :icon="isPlaying(0) ? 'pause' : 'play'" />
                  </a>
                </div>
                <PillsAccent
                  :top="40"
                  :left="-40"
                >
                  <PillColumn>
                    <Pill
                      color="gold"
                      height="medium"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="purple"
                      height="medium"
                      :offset="2"
                    />
                  </PillColumn>
                </PillsAccent>
                <PillsAccent
                  :bottom="0"
                  :right="-120"
                >
                  <PillColumn>
                    <Pill
                      color="paleBlue"
                      height="medium"
                      :offset="2"
                    />
                    <Pill
                      color="mediumBlue"
                      height="xxtall"
                      :offset="1"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="mediumBlue"
                      height="short"
                      :offset="-1"
                    />
                    <Pill
                      color="indigo"
                      height="tall"
                      :offset="1"
                    />
                    <Pill
                      color="paleBlue"
                      height="xxxtall"
                      :offset="0"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="purple"
                      height="tall"
                      :offset="2"
                    />
                    <Pill
                      color="mediumBlue"
                      height="medium"
                    />
                    <Pill
                      color="gold"
                      height="xxtall"
                    />
                  </PillColumn>
                </PillsAccent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section--blue">
      <div class="grid-container">
        <div class="grid-x grid-margin-x align-center">
          <div class="cell medium-6 medium-order-2" data-aos="fade-up">
            <div class="doctor-section-right">
              <div class="doctor-section-content">
                <h3>&ldquo;They are with me through thick and thin, and always a phone call away.&rdquo;</h3>
                <h4>Matthew L. Perkins, MD</h4>
                <h6>Internal Medicine and Pediatrics<br/>Vice Chair of the Board</h6>
                <PillsAccent
                  :top="-110"
                  :right="-70"
                >
                  <PillColumn>
                    <Pill
                      color="indigo"
                      height="xtall"
                    />
                    <Pill
                      color="gold"
                      height="medium"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="purple"
                      height="xtall"
                      :offset="2"
                    />
                  </PillColumn>
                </PillsAccent>
              </div>
            </div>
          </div>
          <div class="cell medium-6 medium-order-1">
            <div class="doctor-section-left">
              <div class="doctor-section-video-wrap">
                <div class="pill-mask">
                  <video
                    class="pill-video"
                    ref="pillVideo2"
                    playsinline=""
                    :poster="`${baseUrl}videos/matthew-perkins-video-placeholder.jpg`"
                    @click="handleVideoClick($event, 1)"
                    @ended="handleVideoEnd($event, 1)"
                  >
                    <source
                      type="video/mp4"
                      :src="`${baseUrl}videos/Matthew-Perkins-Pullquote.mp4`"
                    >
                  </video>
                  <img
                    class="pill-photo"
                    ref="pillPoster2"
                    :src="`${baseUrl}videos/matthew-perkins-video-placeholder.jpg`"
                    @click="handlePosterClick($event, 1)"
                  />
                </div>
                <div class="video-play video-play-right">
                  <a
                    href="#"
                    class="video-play-button"
                    @click="handlePlayButtonClick($event, 1)"
                  >
                    <FontAwesomeIcon :icon="isPlaying(1) ? 'pause' : 'play'" />
                  </a>
                  <div class="video-play-line" />
                  <span class="video-play-text">play video</span>
                </div>
                <PillsAccent
                  :top="40"
                  :left="-90"
                >
                  <PillColumn>
                    <Pill
                      color="purple"
                      height="tall"
                    />
                    <Pill
                      color="paleBlue"
                      height="tall"
                      :offset="3"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="gold"
                      height="xtall"
                      :offset="-1"
                    />
                    <Pill
                      color="indigo"
                      height="xtall"
                    />
                    <Pill
                      color="paleBlue"
                      height="tall"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="purple"
                      height="tall"
                      :offset="2"
                    />
                  </PillColumn>
                </PillsAccent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="grid-container">
        <div class="grid-x grid-margin-x align-center">
          <div class="cell medium-6" data-aos="fade-up">
            <div class="doctor-section-left">
              <div class="doctor-section-content">
                <h3>&ldquo;SVMIC is focused on you and your best interests.&rdquo;</h3>
                <h4>Lisa J. Young, MD</h4>
                <h6>Cardiology<br/>Board Member</h6>
                <PillsAccent
                  :top="-110"
                  :left="-100"
                >
                  <PillColumn>
                    <Pill
                      color="mediumBlue"
                      height="xtall"
                      :offset="3"
                    />
                    <Pill
                      color="indigo"
                      height="medium"
                      :offset="1"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="mediumBlue"
                      height="medium"
                      :offset="2"
                    />
                    <Pill
                      color="gold"
                      height="tall"
                      :offset="1"
                    />
                    <Pill
                      color="mediumBlue"
                      height="short"
                      :offset="1"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="mediumBlue"
                      height="tall"
                    />
                  </PillColumn>
                </PillsAccent>
              </div>
            </div>
          </div>
          <div class="cell medium-6">
            <div class="doctor-section-right">
              <div class="doctor-section-video-wrap">
                <div class="pill-mask">
                  <video
                    class="pill-video"
                    ref="pillVideo3"
                    playsinline=""
                    :poster="`${baseUrl}videos/lisa-young-video-placeholder.jpg`"
                    @click="handleVideoClick($event, 2)"
                    @ended="handleVideoEnd($event, 2)"
                  >
                    <source
                      type="video/mp4"
                      :src="`${baseUrl}videos/Lisa-Young-Pullquote.mp4`"
                    >
                  </video>
                  <img
                    class="pill-photo"
                    ref="pillPoster3"
                    :src="`${baseUrl}videos/lisa-young-video-placeholder.jpg`"
                    @click="handlePosterClick($event, 2)"
                  />
                </div>
                <div class="video-play video-play-left">
                  <span class="video-play-text">play video</span>
                  <div class="video-play-line" />
                  <a
                    href="#"
                    class="video-play-button"
                    @click="handlePlayButtonClick($event, 2)"
                  >
                    <FontAwesomeIcon :icon="isPlaying(2) ? 'pause' : 'play'" />
                  </a>
                </div>
                <PillsAccent
                  :top="-40"
                  :left="-140"
                >
                  <PillColumn>
                    <Pill
                      color="gold"
                      height="medium"
                      :offset="1"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="mediumBlue"
                      height="tall"
                      :offset="2"
                    />
                    <Pill
                      color="paleBlue"
                      height="xxtall"
                      :offset="1"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="paleBlue"
                      height="tall"
                      :offset="2"
                    />
                    <Pill
                      color="purple"
                      height="tall"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="mediumBlue"
                      height="tall"
                      :offset="4"
                    />
                  </PillColumn>
                </PillsAccent>
                <PillsAccent
                  :bottom="60"
                  :right="-70"
                >
                  <PillColumn>
                    <Pill
                      color="paleBlue"
                      height="medium"
                    />
                  </PillColumn>
                  <PillColumn>
                    <Pill
                      color="purple"
                      height="medium"
                      :offset="2"
                    />
                  </PillColumn>
                </PillsAccent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import Pill from '@/components/pills/Pill';
import PillColumn from '@/components/pills/PillColumn';
import PillsAccent from '@/components/pills/PillsAccent';
import PillsRandom from '@/components/pills/PillsRandom';

const videoRefName = (index) => `pillVideo${index + 1}`;

const posterRefName = (index) => `pillPoster${index + 1}`;

export default {
  name: 'Focus',
  components: {
    DefaultPage,
    Pill,
    PillColumn,
    PillsAccent,
    PillsRandom
  },
  data () {
    return {
      playing: [
        false,
        false,
        false
      ],
      baseUrl: process.env.BASE_URL
    };
  },
  methods: {
    play (index) {
      const video = this.$refs[videoRefName(index)];
      const poster = this.$refs[posterRefName(index)];
      poster.classList.add('hide');
      video.play();
      this.$set(this.playing, index, true);
    },
    pause (index) {
      const video = this.$refs[videoRefName(index)];
      video.pause();
      this.$set(this.playing, index, false);
    },
    togglePlaying (index) {
      if (this.playing[index]) {
        this.pause(index);
      } else {
        this.play(index);
      }
    },
    isPlaying (index) {
      return this.playing[index];
    },
    handlePosterClick (event, index) {
      this.play(index);
    },
    handlePlayButtonClick (event, index) {
      event.preventDefault();
      this.togglePlaying(index);
    },
    handleVideoClick (event, index) {
      this.togglePlaying(index);
    },
    handleVideoEnd (event, index) {
      const poster = this.$refs[posterRefName(index)];
      poster.classList.remove('hide');
      this.$set(this.playing, index, false);
    }
  }
};
</script>
